import { LocaleEnum } from '@systemeio/ui'

export const getHelpPageLinkGoogleSheets = (locale?: LocaleEnum) => {
  switch (locale) {
    case LocaleEnum.FRENCH:
      return 'https://aide.systeme.io/article/3735-comment-integrer-google-sheets-a-systemeio'
    case LocaleEnum.SPANISH:
      return 'https://help-es.systeme.io/article/3747-como-integrar-google-sheets-con-systeme-io'
    case LocaleEnum.ITALIAN:
      return 'https://help-it.systeme.io/article/3748-come-integrare-google-sheets-con-systeme-io'
    case LocaleEnum.PORTUGUESE:
      return 'https://help-pt.systeme.io/article/3781-como-integrar-as-planilhas-google-com-a-systeme-io'
    case LocaleEnum.DEUTSCH:
      return 'https://help-de.systeme.io/article/3746-so-integrieren-sie-google-sheets-in-systemeio'
    case LocaleEnum.DUTCH:
      return 'https://help-nl.systeme.io/article/3755-hoe-integreer-je-google-sheets-met-systeme-io'
    case LocaleEnum.JAPANESE:
      return 'https://help-jp.systeme.io/article/3749-how-to-integrate-google-sheets-with-systeme-io'
    case LocaleEnum.ARABIC:
      return 'https://help-ar.systeme.io/article/3981-how-to-integrate-google-sheet-with-systemeio'
    case LocaleEnum.TURKISH:
      return 'https://help-tr.systeme.io/article/4099-google-e-tablolar-systeme-ioya-nasil-entegre-edilir'
    case LocaleEnum.CHINESE:
      return 'https://help-zh.systeme.io/article/4007-how-to-integrate-google-sheets-with-systeme-io'
    case LocaleEnum.HINDI:
      return 'https://help-hi.systeme.io/article/3825-how-to-integrate-google-sheets-with-systeme-io'
    default: {
      return 'https://help.systeme.io/article/3739-how-to-integrate-google-sheets-with-systeme-io'
    }
  }
}
